/* eslint-disable max-len */
import React from "react"
import { observer } from "mobx-react"
import s from "./styles.module.css"

interface IMobileView {
  uploadText: string;
}

function splitByString(source: string, splitBy: string) {
  const splitter: any[] = splitBy.split("")
  splitter.push([source])

  return splitter.reduceRight(function(accumulator: string[], curValue: string) {
    let k: string[] = []
    accumulator.forEach((v: string) => (k = [...k, ...v.split(curValue)]))

    k = k.filter((v: string) => v.length !== 0)

    return k
  })
}

const trophyIcon = (color: "green" | "gray") => (
  <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4491 9.09991L13.731 7.10938L11.8988 8.53119L11.7578 10.5217L13.4491 9.09991Z"
      fill={color === "green" ? "#C8FF88" : "#A3A3A3"}
    />
    <path
      d="M1.35755 9.09893L1.07567 7.1084L2.90789 8.53021L3.04883 10.5207L1.35755 9.09893Z"
      fill={color === "green" ? "#C8FF88" : "#A3A3A3"}
    />
    <path
      d="M12.3223 6.82494L13.027 1.1377L15.0001 1.8486L14.2954 5.26094L12.3223 6.82494Z"
      fill={color === "green" ? "#C8FF88" : "#A3A3A3"}
    />
    <path
      d="M2.67773 6.82494L1.97303 1.1377L-0.000127554 1.8486L0.704573 5.26094L2.67773 6.82494Z"
      fill={color === "green" ? "#C8FF88" : "#A3A3A3"}
    />
    <path
      d="M5.05384 16.7777L10.7195 16.7777L9.59195 15.0714L6.18136 15.0714L5.05384 16.7777Z"
      fill={color === "green" ? "#C8FF88" : "#A3A3A3"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.41797 1.01471L7.58508 0L11.8959 1.01471L10.7463 11.1618L7.58508 13.916L4.42382 11.1618L3.41797 1.01471ZM8.49809 6.36774H8.92784C8.93633 6.36773 8.94473 6.3694 8.95258 6.37265C8.96042 6.37591 8.96754 6.38068 8.97355 6.38671C8.97955 6.39273 8.98431 6.39988 8.98755 6.40776C8.99079 6.41563 8.99245 6.42407 8.99244 6.43259V7.29648C8.99245 7.305 8.99079 7.31345 8.98755 7.32133C8.98431 7.32921 8.97955 7.33637 8.97355 7.3424C8.96755 7.34843 8.96043 7.35322 8.95258 7.35648C8.94474 7.35975 8.93633 7.36143 8.92784 7.36143H8.4807C8.35249 7.35661 8.23114 7.30205 8.14221 7.20922C8.05328 7.1164 8.0037 6.99255 8.00392 6.86377C8.00414 6.73499 8.05414 6.61131 8.14338 6.51879C8.23263 6.42627 8.35416 6.37212 8.48239 6.36774H8.49809ZM6.3567 6.36774H6.78634H6.80215C6.93037 6.37212 7.05191 6.42627 7.14115 6.51879C7.2304 6.61131 7.2804 6.73499 7.28061 6.86377C7.28083 6.99255 7.23126 7.1164 7.14232 7.20922C7.05339 7.30205 6.93205 7.35661 6.80383 7.36143H6.3567C6.33954 7.36143 6.32308 7.35458 6.31094 7.3424C6.29881 7.33022 6.29199 7.3137 6.29199 7.29648V6.43259C6.29199 6.42406 6.29367 6.41562 6.29692 6.40775C6.30017 6.39987 6.30494 6.39272 6.31095 6.3867C6.31696 6.38068 6.32409 6.3759 6.33194 6.37265C6.33979 6.3694 6.3482 6.36773 6.3567 6.36774ZM8.13693 7.7235V8.15486C8.13691 8.1634 8.13522 8.17185 8.13195 8.17973C8.12868 8.18761 8.12389 8.19477 8.11786 8.20079C8.11184 8.20682 8.10468 8.21159 8.09681 8.21483C8.08895 8.21807 8.08052 8.21973 8.07201 8.2197H7.21167C7.19453 8.2197 7.17809 8.21288 7.16596 8.20072C7.15382 8.18856 7.147 8.17207 7.14697 8.15486V7.70594C7.15176 7.57724 7.20612 7.45544 7.2986 7.36618C7.39108 7.27691 7.51446 7.22715 7.64276 7.22737C7.77106 7.22759 7.89427 7.27777 7.98645 7.36735C8.07862 7.45693 8.13257 7.57892 8.13693 7.70763V7.7235ZM8.13693 5.57363V6.005V6.02076C8.13257 6.14947 8.07862 6.27145 7.98645 6.36104C7.89427 6.45062 7.77106 6.5008 7.64276 6.50102C7.51446 6.50124 7.39108 6.45148 7.2986 6.36221C7.20612 6.27295 7.15176 6.15114 7.14697 6.02245V5.57363C7.14697 5.56511 7.14864 5.55667 7.15189 5.54879C7.15515 5.54092 7.15992 5.53377 7.16593 5.52774C7.17194 5.52172 7.17907 5.51695 7.18692 5.5137C7.19477 5.51044 7.20318 5.50878 7.21167 5.50879H8.07201C8.08052 5.50875 8.08896 5.51039 8.09683 5.51363C8.10471 5.51687 8.11186 5.52164 8.1179 5.52767C8.12393 5.53369 8.12871 5.54086 8.13198 5.54874C8.13525 5.55663 8.13693 5.56509 8.13693 5.57363Z"
      fill={color === "green" ? "#C8FF88" : "#A3A3A3"}
    />
  </svg>
)

const coin = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM13.8182 8C13.8182 11.2133 11.2133 13.8182 8 13.8182C4.78671 13.8182 2.18182 11.2133 2.18182 8C2.18182 4.78671 4.78671 2.18182 8 2.18182C11.2133 2.18182 13.8182 4.78671 13.8182 8ZM9.33258 4.53722V5.73722C9.33319 6.09084 9.1933 6.43023 8.94368 6.68071C8.69407 6.93119 8.35517 7.07225 8.00155 7.07286C7.64793 7.07348 7.30855 6.93359 7.05807 6.68397C6.80758 6.43436 6.66652 6.09546 6.66591 5.74184V4.53722C6.66591 4.4913 6.68415 4.44725 6.71663 4.41478C6.7491 4.38231 6.79314 4.36406 6.83907 4.36406H9.15826C9.20419 4.36406 9.24823 4.38231 9.2807 4.41478C9.31318 4.44725 9.33142 4.4913 9.33142 4.53722H9.33258ZM4.53722 6.66804H5.73722C6.09084 6.66743 6.43023 6.80732 6.68071 7.05693C6.93119 7.30655 7.07225 7.64544 7.07287 7.99907C7.07348 8.35269 6.93359 8.69207 6.68397 8.94255C6.43436 9.19303 6.09546 9.3341 5.74184 9.33471H4.53722C4.4913 9.33471 4.44725 9.31646 4.41478 9.28399C4.38231 9.25152 4.36406 9.20747 4.36406 9.16155V6.84236C4.36406 6.79643 4.38231 6.75239 4.41478 6.71991C4.44725 6.68744 4.4913 6.6692 4.53722 6.6692V6.66804ZM11.4639 6.66804H10.2662C9.91256 6.66751 9.57321 6.80747 9.32278 7.05714C9.07235 7.30681 8.93136 7.64573 8.93083 7.99935C8.93029 8.35298 9.07025 8.69233 9.31992 8.94276C9.56959 9.19318 9.90852 9.33417 10.2621 9.33471H11.4639C11.5098 9.33471 11.5538 9.31646 11.5863 9.28399C11.6188 9.25152 11.637 9.20747 11.637 9.16155V6.84236C11.637 6.79643 11.6188 6.75239 11.5863 6.71991C11.5538 6.68744 11.5098 6.6692 11.4639 6.6692V6.66804ZM9.33258 10.2636V11.4636H9.33142C9.33142 11.5096 9.31318 11.5536 9.2807 11.5861C9.24823 11.6185 9.20419 11.6368 9.15826 11.6368H6.83907C6.79314 11.6368 6.7491 11.6185 6.71663 11.5861C6.68415 11.5536 6.66591 11.5096 6.66591 11.4636V10.259C6.66621 10.0839 6.701 9.91059 6.76829 9.74894C6.83557 9.58729 6.93404 9.44047 7.05807 9.31688C7.30855 9.06726 7.64793 8.92737 8.00155 8.92799C8.17665 8.92829 8.34997 8.96308 8.51162 9.03036C8.67327 9.09765 8.82009 9.19612 8.94368 9.32014C9.06728 9.44417 9.16524 9.59132 9.23197 9.75321C9.29869 9.91509 9.33288 10.0885 9.33258 10.2636Z"
      fill="#C8FF88"
    />
  </svg>
)

const MobileView: React.FC<IMobileView> = ({ uploadText }) => {
  const arr: string[] = splitByString(uploadText, "**")

  return (
    <div className={s.containerPhone}>
      <div className={s.phone}>
        {arr?.map((text: string) => {
          if (text.includes("green-prize")) return trophyIcon("green")
          if (text.includes("gray-prize")) return trophyIcon("gray")
          if (text.includes("coin-icon")) return coin()
          if (text.includes("green-text")) {
            const textR = text.replace("green-text!", "")

            return (
              textR.length > 0 && (
                <span className={s.text} style={{ color: "#C8FF88" }}>
                  {text.replace("green-text!", "")}
                </span>
              )
            )
          }
          if (text.includes("gray-text")) {
            const textR = text.replace("gray-text!", "")

            return (
              textR.length > 0 && (
                <span className={s.text} style={{ color: "#A3A3A3" }}>
                  {text.replace("gray-text!", "")}
                </span>
              )
            )
          }

          if (text.includes("white-text")) {
            const textR = text.replace("white-text!", "")

            return (
              textR.length > 0 && (
                <span className={s.text} style={{ color: "#EAEAEA" }}>
                  {text.replace("white-text!", "")}
                </span>
              )
            )
          }
          if (text.includes("wrap-new-line")) return <br key={text} />
        })}
      </div>
    </div>
  )
}

export default observer(MobileView)
